var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 60.771,
    y: 181.966,
    style: {
      fill: "#C9E8FA"
    },
    width: 390.457,
    height: 241.058
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 181.966,
    style: {
      fill: "#B6E0F7"
    },
    width: 195.229,
    height: 241.058
  }), /*#__PURE__*/React.createElement("rect", {
    y: 438.698,
    style: {
      fill: "#57555C"
    },
    width: 512,
    height: 72.652
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67BFFF"
    },
    d: "M45.098,166.288v272.405h421.804V166.288L45.098,166.288L45.098,166.288z M435.555,407.346H76.445 V197.635h359.111V407.346z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0088FF"
    },
    points: "466.902,166.288 466.902,438.693 256,438.693 256,407.346 435.555,407.346 435.555,197.635  256,197.635 256,166.288 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 438.698,
    style: {
      fill: "#3C3A41"
    },
    width: 256,
    height: 72.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.164,
    y: 466.283,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.671,
    height: 21.682
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 466.283,
    style: {
      fill: "#D9D8DB"
    },
    width: 10.836,
    height: 21.682
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#57555C"
    },
    points: "364.669,121.368 316.322,121.368 316.322,0.65 195.678,0.65 195.678,121.368  147.331,121.368 256,270.474 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C3A41"
    },
    points: "316.322,0.65 256,0.65 256,270.474 364.669,121.368 316.322,121.368 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/input.b8253bbe780a5010d39f9b08078d8037.svg";
export { ForwardRef as ReactComponent };